import React, { useState } from 'react';
import './Analysisfood.css';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell, } from "recharts";




const Analysisfood = () => {

    const veg = [
        { name: "Chicken Biryani", value: 15, color: "#E8C3A0" },
        { name: "Chicken 65", value: 10, color: "#9B59B6" },
        { name: "veg meals", value: 10, color: "#9B59B6" },
       
      ];

    const payment = [
        { name: "Debit Card", value: 30.95 },
        { name: "Credit Card", value: 20.89 },
        { name: "Cash on Delivery", value: 15.84 },
        { name: "UPI", value: 30.84 },
        
    ];

    const COLORS1 = ["#3498db", "#e74c3c", "#000", "#FFA500", "#4CAF50"]; // Blue, Red, Green, Orange



    const data6 = [
        { name: "New Customers", value: 32 },
        { name: "Returning Customers", value: 68 }
    ];

    const COLORS = ["#4CAF50", "#FFA500"]; // Green and Orange






    const [activeTab, setActiveTab] = useState('Overview');
    const data5 = [
        { day: "Mon", "Dine In": 400, "Pick Up": 300, Delivery: 200, },
        { day: "Tues","Dine In": 300, "Pick Up": 350, Delivery: 100,  },
        { day: "Wed", "Dine In": 450, "Pick Up": 200, Delivery: 100,  },
        { day: "Thurs", "Dine In": 200, "Pick Up": 100, Delivery: 400, },
        { day: "Fri","Dine In": 100, "Pick Up": 200, Delivery: 100, },
        { day: "sat", "Dine In": 300, "Pick Up": 200, Delivery: 100, },
        { day: "sun","Dine In": 200, "Pick Up": 300, Delivery: 300, },

    ];

    const [data, setData] = useState([
        {
            SNo: '1',
            category: 'Tiffins',
            type: 'Veg',
            image: '',
            name: 'Dosa',
            price: '₹40',
            price1: '₹30',
        },
        {
            SNo: '2',
            category: 'Biryani',
            type: 'Non-Veg',
            image: '',
            name: 'Biryani',
            price: '₹150',
            price1: '₹120',
        },
    ]);

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const updatedData = [...data];
        updatedData[index][name] = value;
        setData(updatedData);
    };


    // {=======================overview===============================}
    const tabContent = {


    }



    return (
        <div style={{ overflowY: 'auto', height: '550px',  marginTop: '30px', scrollbarWidth: "none" }}>
            {/* Tab Buttons */}
            <div style={{ gap: '10px', display: 'flex', justifyContent: 'space-evenly' }}>
                {Object.keys(tabContent).map((label) => (
                    <button
                        key={label}
                        onClick={() => setActiveTab(label)}
                        style={{
                            border: 'none',
                            borderRadius: '10px',
                            width: '100px',
                            height: '40px',
                            backgroundColor: activeTab === label ? '#b15cd6' : '#d9d9d9',
                            color: '#000',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                        }}
                    >
                        {label}
                    </button>
                ))}

            </div>

            {/* Tab Content */}
            <div style={{ marginTop: '-10px', padding: '20px', borderRadius: '8px', }}>
                <div>
                    <div className="status-overview5">
                        <div style={{ background: "gray", color: "#fff" }} className="status-card5">
                            <h3 style={{ display: 'flex', justifyContent: "center" }}>Total Orders</h3>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Dine In: 50</p>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Pick Up: 40</p>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Delivery: 10</p>
                        </div>
                        <div style={{ background: "gray", color: "#fff" }} className="status-card5">
                            <h3 style={{ display: 'flex', justifyContent: "center" }}>Total Revenue</h3>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Dine In: 30%</p>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Pick Up: 11%</p>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Delivery: 29%</p>
                        </div>
                        <div style={{ background: "gray", color: "#fff" }} className="status-card5">
                            <h3 style={{ display: 'flex', justifyContent: "center" }}>Total Customers</h3>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Dine In: 200</p>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Pick Up: 50</p>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Delivery: 50</p>
                        </div>
                    </div>
                    {/* <div className="status-overview5"> */}
                        <div style={{ background: "gray", color: "#fff" }} className="status-card5">
                            <h3 style={{ display: 'flex', justifyContent: "center" }}>Success rate</h3>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Dine In: 93.33%</p>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Pick Up: 92.44%</p>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Delivery: 98.55%</p>
                        </div>
                        <div style={{ background: "gray", color: "#fff" }} className="status-card5">
                            <h3 style={{ display: 'flex', justifyContent: "center" }}>Cancel/Refund</h3>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Dine In: 6.67%</p>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Pick Up: 7.85%</p>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Delivery: 2.55%</p>
                        </div>
                        <div style={{ background: "gray", color: "#fff" }} className="status-card5">
                            <h3 style={{ display: 'flex', justifyContent: "center" }}>Abandonment Rate</h3>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Dine In: 10.0%</p>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Pick Up: 2.00%</p>
                            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Delivery: 4.0%</p>
                        </div>
                    </div>

               
            </div>
            <div>
                <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                    <div style={{ padding: "16px", }}>
                        <h2 style={{ fontSize: "24px", fontWeight: "bold", color: "red", marginBottom: "16px", marginLeft: "50px" }}>Sales Growth Chart</h2>
                        <ResponsiveContainer width="100%" height={300}>
                            <LineChart data={data5} margin={{ top: 10, right: 10, left: -25, bottom: 10 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="day" />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                <Line type="monotone" dataKey="Dine In" stroke="#d62728" dot={{ r: 5 }} />
                                <Line type="monotone" dataKey="Pick Up" stroke="#1f77b4" dot={{ r: 5 }} />
                                <Line type="monotone" dataKey="Delivery" stroke="#000" dot={{ r: 5 }} />
                                
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                    <div>
                        <div style={{}}>
                        <h2 style={{ fontSize: "24px", fontWeight: "bold", color: "red", marginBottom: "10px", marginLeft: "80px",marginTop:"10px" }}>Top selling Items</h2>
                            <PieChart width={330} height={300}>
                                <Pie
                                    data={veg}
                                    cx={185}
                                    cy={120}
                                    outerRadius={80}
                                    dataKey="value"
                                    label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                                >
                                    {data.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={entry.color || "#000"} />
                                    ))}
                                </Pie>
                                <Tooltip />
                                <Legend />
                            </PieChart>
                        </div>
                    </div>
                </div>
                <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                    <div style={{ padding: "16px", }}>
                        <h2 style={{ fontSize: "24px", fontWeight: "bold", color: "red", marginBottom: "16px", marginLeft: "50px" }}>Returning vs New Customers</h2>
                        <ResponsiveContainer width="100%" height={300}>
                            <PieChart>
                                <Pie
                                    data={data6}
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={60}
                                    outerRadius={120}
                                    fill="#8884d8"
                                    dataKey="value"
                                    label
                                >
                                    {data.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index]} />
                                    ))}
                                </Pie>
                                <Tooltip />
                                <Legend />
                            </PieChart>
                        </ResponsiveContainer>
                    </div>
                    <div>
                        <div style={{ padding: "16px", textAlign: "center" }}>
                            <h2 style={{ fontSize: "24px", fontWeight: "bold", color: "red", marginBottom: "16px" }}>
                                Most Preferred Payment
                            </h2>
                            <ResponsiveContainer width="100%" height={300}>
                                <PieChart>
                                    <Pie
                                        data={payment}
                                        cx="50%"
                                        cy="50%"
                                        outerRadius={80}
                                        fill="#8884d8"
                                        dataKey="value"
                                        label={({ percent }) => `${(percent * 100).toFixed(2)}%`}
                                    >
                                        {data.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={COLORS1[index]} />
                                        ))}
                                    </Pie>
                                    <Tooltip />
                                    <Legend />
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ marginLeft: "50px" }}>
                <h3 style={{ color: "red" }}>Recommendations</h3>
                <p style={{ fontWeight: "bold" }}>"Peak seales happen between 7-9PM. Consider discounts!"</p>
                <p style={{ fontWeight: "bold" }}>"80% of Customers prefer online payments. Reduce COD options!"</p>
                <p style={{ fontWeight: "bold" }}>"Refund Rate incresed by 5%. Analyze refund reasons!"</p>
            </div>

        </div>
    );
};

const tableHeaderStyle = {
    padding: '12px',
    border: '1px solid #ddd',
    textAlign: 'center',
    fontWeight: 'bold',
    backgroundColor: '#b15cd6',
    color: 'white',
};

const tableCellStyle = {
    padding: '12px',
    border: '1px solid #ddd',
    textAlign: 'center',
};

const evenRowStyle = {
    backgroundColor: '#f9f9f9',
};

const oddRowStyle = {
    backgroundColor: '#fff',
};
const inputStyle = {
    width: '100%',
    border: 'none',
    backgroundColor: 'transparent',
    textAlign: 'center',
};

export default Analysisfood;
